/**
 * @internalapi
 */
export var StorageKey;
(function (StorageKey) {
    StorageKey["TRANSPORT_P2P_PEERS_DAPP"] = "beacon:communication-peers-dapp";
    StorageKey["TRANSPORT_P2P_PEERS_WALLET"] = "beacon:communication-peers-wallet";
    StorageKey["TRANSPORT_POSTMESSAGE_PEERS_DAPP"] = "beacon:postmessage-peers-dapp";
    StorageKey["TRANSPORT_POSTMESSAGE_PEERS_WALLET"] = "beacon:postmessage-peers-wallet";
    StorageKey["TRANSPORT_WALLETCONNECT_PEERS_DAPP"] = "beacon:walletconnect-peers-dapp";
    StorageKey["LAST_SELECTED_WALLET"] = "beacon:last-selected-wallet";
    StorageKey["ACCOUNTS"] = "beacon:accounts";
    StorageKey["ACTIVE_ACCOUNT"] = "beacon:active-account";
    StorageKey["PUSH_TOKENS"] = "beacon:push-tokens";
    StorageKey["BEACON_SDK_SECRET_SEED"] = "beacon:sdk-secret-seed";
    StorageKey["BEACON_LAST_ERROR"] = "beacon:beacon-last-error";
    StorageKey["APP_METADATA_LIST"] = "beacon:app-metadata-list";
    StorageKey["PERMISSION_LIST"] = "beacon:permissions";
    StorageKey["ONGOING_PROOF_OF_EVENT_CHALLENGES"] = "beacon:ongoing-proof-of-event-challenges";
    StorageKey["BEACON_SDK_VERSION"] = "beacon:sdk_version";
    StorageKey["MATRIX_PRESERVED_STATE"] = "beacon:sdk-matrix-preserved-state";
    StorageKey["MATRIX_PEER_ROOM_IDS"] = "beacon:matrix-peer-rooms";
    StorageKey["MATRIX_SELECTED_NODE"] = "beacon:matrix-selected-node";
    StorageKey["MULTI_NODE_SETUP_DONE"] = "beacon:multi-node-setup";
    StorageKey["USER_ID"] = "beacon:user-id";
    StorageKey["ENABLE_METRICS"] = "beacon:enable_metrics";
    StorageKey["WC_INIT_ERROR"] = "beacon:wc-init-error";
    StorageKey["WC_2_CORE_PAIRING"] = "wc@2:core:0.3:pairing";
    StorageKey["WC_2_CLIENT_SESSION"] = "wc@2:client:0.3:session";
    StorageKey["WC_2_CORE_KEYCHAIN"] = "wc@2:core:0.3:keychain";
    StorageKey["WC_2_CORE_MESSAGES"] = "wc@2:core:0.3:messages";
    StorageKey["WC_2_CLIENT_PROPOSAL"] = "wc@2:client:0.3:proposal";
    StorageKey["WC_2_CORE_SUBSCRIPTION"] = "wc@2:core:0.3:subscription";
    StorageKey["WC_2_CORE_HISTORY"] = "wc@2:core:0.3:history";
    StorageKey["WC_2_CORE_EXPIRER"] = "wc@2:core:0.3:expirer";
})(StorageKey || (StorageKey = {}));
//# sourceMappingURL=StorageKey.js.map